var map = {
	"./4-Bannett.webp": 6565,
	"./4-Barbara.webp": 5187,
	"./4-Beidou.webp": 1530,
	"./4-Chongyun.webp": 2637,
	"./4-Diona.webp": 3054,
	"./4-Fischl.webp": 9852,
	"./4-Ningguang.webp": 5789,
	"./4-Noelle.webp": 5496,
	"./4-Razor.webp": 3110,
	"./4-Rosaria.webp": 7067,
	"./4-Sara.webp": 6519,
	"./4-Sayu.webp": 8548,
	"./4-Sucrose.webp": 6873,
	"./4-Thoma.webp": 5408,
	"./4-Xiangling.webp": 591,
	"./4-Xingqiu.webp": 527,
	"./4-Xinyan.webp": 2487,
	"./4-Yanfei.webp": 4066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8238;